let initialFormValues: Record<string, any> = {};
let initialServiceRequestType = '';

export const setInitialFormValues = (values: Record<string, any>) => {
  initialFormValues = values;
};

export const getInitialFormValues = (): Record<string, any> => {
  return initialFormValues;
};

export const setServiceRequestType = (serviceType: string) => {
  initialServiceRequestType = serviceType;
};

export const getServiceRequestType = (): string => {
  return initialServiceRequestType;
};
